export default {
  NODE_ENV: 'production',
  ADVISORS_PERM_UNWINDING: [],
  API_RFQ_ENDPOINT: 'https://prd-lb.xpinc.io/xp-treasury-customquote/api/v1',
  API_URL: 'https://api-advisor.xpi.com.br/corporate-black-cotizador-apim/v1/api',
  API_URL_LEGACY: 'https://api-advisor.xpi.com.br/corporate-black-cotizador-apim',
  API_URL_PUSH: 'https://api-advisor.xpi.com.br/corporate-black-cotizador-apim/v1',
  BLACK_HEADER_URL: 'https://black.xpi.com.br/header/index.min.js',
  SUBSCRIPTION_KEY: 'b63f9758680845afb25dbd47a5e95c4a',
  REACT_APP_API_UNWINDING: 'https://api-advisor.xpi.com.br/corporate-black-cotizador-apim/v1/api/Unwinding',
  REACT_APP_API_UNWINDING_FILTERED: 'https://api-advisor.xpi.com.br/corporate-black-cotizador-apim/v1/api/Unwinding/filtered',
  XP_SESSION_URL: 'https://black.xpi.com.br/session/dist/main.js',

  AUTH_DOMAIN: 'https://advisor.xpi.com.br',
  AUTH_CLIENT_ID: 'bVOtk276PtIaBfrlDlCdUSqdN6ph7wCr',
  DOMAIN_PATH: '/produtos-estruturados/#',
};
